module.exports = __webpack_public_path__ + "static/curve-analysis-gif-bfb4ad3f1bc2bbea7eceedb2413fe6a2.gif";